import React, { createContext, useContext, useState, useEffect } from "react";
import { API_BASE_URL } from "../../config";

const CartContext = createContext();

export function useCart() {
    return useContext(CartContext);
}

export function CartProvider({ children }) {
    const [count, setCount] = useState(0);

    const refreshCart = () => {
        fetch(`${API_BASE_URL}/api/customer/cart`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        })
            .then(res => res.json())
            .then(data => setCount(Array.isArray(data) ? data.length : 0))
            .catch(() => setCount(0));
    };

    useEffect(() => {
        refreshCart();
    }, []);

    return (
        <CartContext.Provider value={{ count, refreshCart }}>
            {children}
        </CartContext.Provider>
    );
}
